import cx from 'classnames'

import { ReactComponent as Chevron } from 'assets/icons/chevronRight24.svg'
import { ReactComponent as Logo } from 'assets/icons/logo40.svg'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

import Styles from './LinkCards.module.scss'
import { HELP_CENTER_URL } from 'utils/constants'

export const HelpCenterCard = () => {
  const { isTabletPortrait } = useResponsiveDesign()

  return (
    <a href={HELP_CENTER_URL} target="_blank" rel="noreferrer" className={Styles.option}>
      <div className={cx(Styles.left, Styles.purple, { [Styles.mobile]: isTabletPortrait })}>
        <Logo />
      </div>
      <div className={Styles.right}>
        <div className={Styles.optionTitle}>Blaze Help Center</div>
        <div className={Styles.optionSubtitle}>Learn everything about Blaze</div>
      </div>
      <div className={Styles.chevronContainer}>
        <Chevron />
      </div>
    </a>
  )
}
